import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { ImmagineFormType, Persona } from "../../types"
import ImmagineForm from "./ImmagineForm"
import { useNavigate, useParams } from "react-router-dom"
import { useImmagine, useImmagineDelete, useImmaginePartialUpdate } from "../../hooks/immagini"
import { Formik } from "formik"
import { initialValuesImmagine, validationSchemaImmagine } from "./ImmagineCommon"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import ModalDelete from "../../components/ModalDelete"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function ImmagineUpdate() {
  const updateImmagine = useImmaginePartialUpdate()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: immagine } = useImmagine(Number(id))

  useBreadcrumbs([{ label: "Immagini", href: "/edizioni/immagini" }, { label: "Dettaglio Immagine" }])

  const [modalStateDeleteImmagine, modalActionsDeleteImmagine] = useModalTrigger()

  const deleteImmagine = useImmagineDelete()

  const initialValues = useMemo(() => initialValuesImmagine(immagine), [immagine])
  const validationSchema = useMemo(() => validationSchemaImmagine(true), [])

  const title = useMemo(() => {
    if(!immagine) return <>&nbsp;</>
    return immagine.titolo.length > 30 ? immagine.titolo.substring(0,30)+"..." : immagine.titolo
  }, [immagine])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{title}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteImmagine.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              const payload = { ...values }
              if(typeof payload.immagine === "string") {
                delete payload.immagine
              }
              return updateImmagine.mutateAsync(payload as ImmagineFormType).then(() => {
                navigate(`/edizioni/immagini`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <ImmagineForm showEdizione col={8} />
                </Container>
                <BottomFormFixed url="/edizioni/immagini" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteImmagine.isOpen}
        onClose={modalActionsDeleteImmagine.close}
        onDelete={() => {
          return deleteImmagine.mutateAsync(immagine?.id).then(() => {
            navigate(`/edizioni/immagini`)
          })
        }}
        message="Sei sicuro di voler eliminare questa immagine?"
        title="Elimina immagine"
      />
    </Layout>
  )
}
